import { EventCodes } from '../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.ContextSelectionViewController', [
	'mx.shell.SidePanelService',
	'mx.shell.ContextService',
	'mx.shell.SidePanelActionsService',
	'mx.shell.DetailsView',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.shell.NavigationService',
	'$scope',
	function contextSelectionViewController(
		sidePanelService,
		contextService,
		sidePanelActionsService,
		DetailsView,
		i18n,
		eventService,
		dialogOpener,
		schemaService,
		navigationService,
		$scope
	) {
		const vm = this;
		vm.mxSidePanel = sidePanelService;
		vm.mxContextService = contextService;
		vm.mxSidePanelActions = sidePanelActionsService;
		vm.maxItemsToShow = 50;
		vm.entityClassName = null;
		vm.objectsLinkLabel = null;

		vm.openViewFromSelection = openViewFromSelection;
		vm.selectionListChange = selectionListChange;

		vm.$onInit = function () {
			init();
		};

		async function init() {
			const setViewTitle = (count) => (vm.view.displayName = `${count} ${i18n.get('shell.mx-search.items_selected')}`);
			const selectionCount = contextService.selectedObjects.length;

			setViewTitle(selectionCount);

			if (selectionCount > 0) {
				if (contextService.selectedObjects[0]._type.startsWith('service_')) {
					vm.isService = true;
				} else {
					const typeInfo = await schemaService.getType(contextService.selectedObjects[0]._type);
					if (typeInfo) {
						vm.entityClassName = typeInfo.MainClassName;
						vm.objectsLinkLabel = contextService.actionsContext.types.length > 1 ? navigationService.currentItem.title : typeInfo.DisplayName;
					} else {
						vm.isMultiFragment = true;
					}
				}
			}

			eventService.subscribeTo(mx.shell.EventCodes.ObjectSelectionChanged, (eventObj, selectedObjects) => setViewTitle(selectedObjects.length), $scope);
		}

		async function openViewFromSelection(item) {
			const view = await dialogOpener.openPreview(item, undefined, undefined, vm.view);
			if (view) {
				eventService.dispatchEvent(EventCodes.TrackViewTelemetry, { eventName: `Selection view: item clicked`, view });
			}
		}

		function selectionListChange() {
			contextService.selectedObjects = contextService.selectedObjects.filter(function (object) {
				return object.__isSelected;
			});
		}
	},
]);
